import { useRef, useState } from 'react';
import DialogTemplate from '@/components/common/dialog-template/dialog-template';
import { QRCodeSVG } from 'qrcode.react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import html2canvas from 'html2canvas';
import { ButtonGroup } from '@mui/material';
import { useTranslate } from 'react-admin';

const optionsMIME = [
    { label: 'jpeg', MIME: 'image/jpeg', format: 'jpeg' },
    { label: 'svg', MIME: 'image/svg', format: 'svg' },
    { label: 'png', MIME: 'image/png', format: 'png' },
];

const optionsSize = [
    { label: '200px', size: 200 },
    { label: '300px', size: 300 },
    { label: '400px', size: 400 },
];

interface Props {
    open: boolean;
    onClose: any;
    url: string;
    downloadName: string;
}

const ShowQrDialog = ({ open, onClose, url, downloadName }: Props) => {
    const qrCodeContainer: any = useRef(null);
    const translate = useTranslate();
    const [selectedMIME, setSelectedMIME] = useState(optionsMIME[0]);
    const [selectedSize, setSelectedSize] = useState<any>(optionsSize[0]);

    const downloadQrCode = () => {
        const { MIME: type, format } = selectedMIME;
        html2canvas(qrCodeContainer.current).then((canvas) => {
            let a = document.createElement('a');
            a.href = canvas.toDataURL(type).replace(type, 'image/octet-stream');
            a.download = `${downloadName}.${format}`;
            a.click();
        });
    };

    return (
        <DialogTemplate open={open} onClose={onClose}>
            <Box
                sx={{
                    display: 'grid',
                    gap: 2,
                    justifyContent: 'center',
                    justifyItems: 'center',
                }}
            >
                <Box
                    ref={qrCodeContainer}
                    sx={{
                        backgroundColor: 'white',
                        p: '10px 10px 5px 10px',
                    }}
                >
                    <QRCodeSVG value={url} size={selectedSize.size} />
                </Box>

                <ButtonGroup variant='contained' size='small' disableElevation>
                    {optionsMIME.map((option) => (
                        <Button
                            key={option.label}
                            onClick={() => setSelectedMIME(option)}
                            sx={{
                                ...(selectedMIME.label === option.label && { backgroundColor: '#E0E0E0' }),
                            }}
                        >
                            {option.label}
                        </Button>
                    ))}
                </ButtonGroup>

                <ButtonGroup variant='contained' size='small' disableElevation>
                    {optionsSize.map((optionSize) => (
                        <Button
                            key={optionSize.label}
                            onClick={() => setSelectedSize(optionSize)}
                            sx={{
                                ...(selectedSize.label === optionSize.label && {
                                    backgroundColor: '#E0E0E0',
                                }),
                            }}
                        >
                            {optionSize.label}
                        </Button>
                    ))}
                </ButtonGroup>

                <Button variant={'contained'} onClick={downloadQrCode}>
                    {translate('buttons.download')}
                </Button>
            </Box>
        </DialogTemplate>
    );
};

export default ShowQrDialog;
